import BaseObject from "@shared/BaseObject.js";

export default class FormScaleConfig extends BaseObject {
	max: number = 10

	constructor(options = {}) {
		super(options);
		this.applyOptions(options)
	}
}
